import React from "react";
import { formatDateWithoutTime } from "../../utils/formateDate";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Chart } from "react-google-charts";


export const options = {
  legend: 'none',
    datalessRegionColor: "#cec9d5",
    colorAxis: { 
       colors: ['#c2a3e7', '#954cea'], // Optional color customization
      showScale: false // This hides the color scale (progress bar)
    },

  
//   datalessRegionColor: "#f8bbd0",
//   defaultColor: "#f5f5f5",
};

const GeoCharts = ({ members }) => {
  const { t } = useTranslation();
  return (
    <div className="col-md-6">
      <div className="joinings_viewBox">
             <h5>{t("joinings")}</h5>
        <Chart
          chartEvents={[
            {
              eventName: "select",
              callback: ({ chartWrapper }) => {
             
              },
            },
          ]}
         
          chartType="GeoChart"
          width="100%"
          height="90%"
          data={members}
          options={options}
        />
      </div>
    </div>
  );
};

export default GeoCharts;
